<template>
  <vx-card
    id="vessel-voyage-history-camera"
    class="overflow-hidden"
    v-on="$listeners"
  >
    <template slot="no-body">
      <div class="live-camera-area">
        <P>{{ cameraMsg }}</P>
        <vs-button
          v-if="hasVideoError"
          icon-pack="feather"
          icon="icon-rotate-cw"
          color="rgb(255, 255, 255)"
          type="line"
          size="small"
          @click="connect"
          >{{ retryText }}</vs-button
        >
        <video-player
          v-show="onPlayer1"
          class="media-video-player card-video
        vjs-big-play-centered video-player-window"
          ref="videoPlayer1"
          :options="playerOptions"
          @ready="onPlayerReadied(1)"
          @ended="onPlayerEnded(1)"
          @waiting="onPlayerWaiting($event)"
          @playing="onPlayerPlaying(1)"
          @loadeddata="onPlayerLoadeddata(1)"
          @error="onPlayerError"
        />
        <video-player
          v-show="onPlayer2"
          class="media-video-player card-video vjs-big-play-centered video-player-window"
          ref="videoPlayer2"
          :options="playerOptions"
          @ready="onPlayerReadied(2)"
          @ended="onPlayerEnded(2)"
          @waiting="onPlayerWaiting(2)"
          @playing="onPlayerPlaying(2)"
          @loadeddata="onPlayerLoadeddata(2)"
          @error="onPlayerError"
        />
        <video-player
          v-show="onPlayer3"
          class="media-video-player card-video vjs-big-play-centered video-player-window"
          ref="videoPlayer3"
          :options="playerOptions"
          @ready="onPlayerReadied(3)"
          @ended="onPlayerEnded(3)"
          @waiting="onPlayerWaiting($event)"
          @playing="onPlayerPlaying(3)"
          @loadeddata="onPlayerLoadeddata(3)"
          @error="onPlayerError"
        />
        <video-player
          v-show="onPlayer4"
          class="media-video-player card-video vjs-big-play-centered video-player-window"
          ref="videoPlayer4"
          :options="playerOptions"
          @ready="onPlayerReadied(4)"
          @ended="onPlayerEnded(4)"
          @waiting="onPlayerWaiting($event)"
          @playing="onPlayerPlaying(4)"
          @loadeddata="onPlayerLoadeddata(4)"
          @error="onPlayerError"
        />
      </div>
    </template>
  </vx-card>
</template>

<script>
import { videoPlayer } from "vue-videojs7";
import videojs from "video.js";
import { DateUtil } from "@/utils";

import { createNamespacedHelpers } from "vuex";

// Store
const {
  mapActions: mapActionsOfVesselView,
} = createNamespacedHelpers("enterpriseVesselView");

const {
  mapState: mapStateOfEnterpriseVesselVoyageHistory,
  mapGetters: mapGettersOfEnterpriseVesselVoyageHistory
} = createNamespacedHelpers("enterpriseVesselVoyageHistory");

export default {
  components: {
    videoPlayer
  },
  props: {
    camera: {
      type: Object,
      required: true
    },
    startTimUtc: {
      type: String,
      required: true
    },
    endTimeUtc: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      cameraUrls: null,
      onPlayer1: true,
      player1Init: false,
      onPlayer2: false,
      onPlayer3: false,
      onPlayer4: false,
      initialized: false,
      hasVideoError: false,
      retryText: "",
      cameraMsg: "",
      errorDisplay: null,
      playerOptions: {
        width: "180",
        autoplay: false,
        muted: true,
        preload: "auto",
        fullscreen: false,
        bigPlayButton: false,
        flash: { hls: { withCredentials: false } },
        html5: { hls: { withCredentials: false } },
        language: "ja",
        languages: {
          ja: {
            Play: "再生",
            "The media could not be loaded, either because the server or network failed or because the format is not supported.":
              "再生できませんでした"
          }
        },
        controlBar: {
          remainingTimeDisplay: false,
          pictureInPictureToggle: false,
          playToggle: false,
          progressControl: {
            seekBar: false
          }
        }
      },
      storeUnsubscribe: null,
      videoTimeIndex: []
    };
  },
  watch: {
    camera: {
      immediate: true,
      handler() {
        this.setLibraryCameras();
      }
    },
    voyageHistoryPlayerCurrentTime(value) {
      let from = "2020-08-30T15:00:00";
      let to = DateUtil.unixTimeFormatter(value, "YYYY-MM-DDTHH:mm:ss");
      let diffSec = DateUtil.diff(from, to, "s");
      this.onPlayerPlay(this.videoTimeIndex[diffSec]);
    },
    voyageHistoryPlayerIsPause(value) {
      if (value) {
        this.onPlayerPause();
      }
    }
  },
  computed: {

    ...mapStateOfEnterpriseVesselVoyageHistory({
      voyageHistoryPlayerCurrentTime: state => state.current_time,
      voyageHistoryPlayerIsPause: state => state.is_pause
    }),

    ...mapGettersOfEnterpriseVesselVoyageHistory(["getFPS"]),

    player1() {
      return this.$refs.videoPlayer1.player;
    },
    player2() {
      return this.$refs.videoPlayer2.player;
    },
    player3() {
      return this.$refs.videoPlayer3.player;
    },
    player4() {
      return this.$refs.videoPlayer4.player;
    }
  },
  methods: {
    ...mapActionsOfVesselView([
      "setCurrentTime",
      "setVideoDuration",
      "fetchVesselVoyageHistoryCameraUrls"
    ]),

    async setLibraryCameras() {
      this.cameraMsg = "取得中...";
      // テスト用
      let payload = {
        hash:
          "a5866283f7207b6e7824f59fba132833941d7c3e1f81339ae2c198f722636fed",
        startTime: "2020-09-08T14:30:00",
        endTime: "2020-09-08T15:00:00"
      };
      // let payload = {
      //   hash: this.camera.hash,
      //   startTime: this.startTime,
      //   endTime: this.endTime
      // };
      this.cameraUrls = await this.fetchVesselVoyageHistoryCameraUrls(payload);
      if (!this.cameraUrls) {
        this.cameraMsg = "映像なし";
        return;
      }
      let player1StartDiff = DateUtil.diff(
        this.cameraUrls[0].startTime,
        this.cameraUrls[0].historyDate,
        "seconds"
      );
      this.cameraUrls.forEach((v, i) => {
        let loopTime = 600;
        if (i === 0 || i === 3) {
          loopTime = 600 - player1StartDiff;
        }
        if (this.videoTimeIndex.length !== 1800) {
          for (let j = 0; j < loopTime; j++) {
            let indexData = {
              videoIndex: i,
              currentTime: player1StartDiff + j
            };
            this.videoTimeIndex.push(indexData);
          }
        }
      });

      this.cameraMsg = "";
      this.player1.src(this.cameraUrls[1]);
      this.player2.src(this.cameraUrls[1]);
      this.player3.src(this.cameraUrls[1]);
      this.player4.src(this.cameraUrls[1]);
    },

    onPlayerReadied(_) {
      if (!this.initialized) {
        this.initialized = true;
      }
    },

    onPlayerPause() {
      this.player1.pause();
      this.player2.pause();
      this.player3.pause();
      this.player4.pause();
    },

    onPlayerPlay(indexDate) {
      switch (indexDate.videoIndex) {
        case 1:
          if (indexDate.currentTime) {
            this.player1.currentTime(indexDate.currentTime);
          }
          this.onPlayer1 = true;
          this.onPlayer2 = false;
          this.onPlayer3 = false;
          this.onPlayer4 = false;
          break;
        case 2:
          if (indexDate.currentTime) {
            this.player2.currentTime(indexDate.currentTime);
          }
          if (this.getFPS === 1) {
            this.player2.play();
          }
          this.onPlayer1 = false;
          this.onPlayer2 = true;
          this.onPlayer3 = false;
          this.onPlayer4 = false;
          break;
        case 3:
          if (indexDate.currentTime) {
            this.player3.currentTime(indexDate.currentTime);
          }
          this.onPlayer1 = false;
          this.onPlayer2 = false;
          this.onPlayer3 = true;
          this.onPlayer4 = false;
          break;
        case 4:
          if (indexDate.currentTime) {
            this.player4.currentTime(indexDate.currentTime);
          }
          this.player4.play();
          this.onPlayer1 = false;
          this.onPlayer2 = false;
          this.onPlayer3 = false;
          this.onPlayer4 = true;
          break;
      }
    },
    onPlayerEnded(index) {
      console.log(`player-${index} onPlayerEnded`);
      let indexData = {
        videoIndex: index + 1,
        currentTime: null
      };
      this.onPlayerPlay(indexData);
    },
    onPlayerWaiting() {},
    onPlayerPlaying() {},
    onPlayerError() {
      this.cameraMsg = "";
      this.retryText = "もう一度接続";
      this.hasVideoError = true;
    },

    onPlayerTimeupdate() {},

    onPlayerLoadeddata(index) {
      switch (index) {
        case 1:
          console.log("this.player1 duration = ", this.player1.duration());
          break;
        case 2:
          console.log("this.player2 duration = ", this.player2.duration());
          break;
        case 3:
          console.log("this.player3 duration = ", this.player3.duration());
          break;
        case 4:
          console.log("this.player4 duration = ", this.player4.duration());
          break;
      }
    },

    errorHandler() {
      this.player.reset();
      let ErrorDisplay = videojs.getComponent("ErrorDisplay");
      this.errorDisplay = new ErrorDisplay(this.player1, {
        temporary: false
      });
      this.player1.addChild(this.errorDisplay);
      this.cameraMsg = "";
      this.player1.error("接続失敗");
      // this.retryText = "もう一度接続";
      // this.hasVideoError = true;
    },

    cleanup() {
      this.retryText = "";
      this.hasVideoError = false;
      this.hidePlayButton();
      if (this.player1) {
        this.player1.error(null);
        this.player1.removeChild(this.errorDisplay);
        this.player1.reset();
      }
    },

    hidePlayButton() {
      let playButton = this.player1
        .contentEl()
        .getElementsByClassName("vjs-big-play-button");
      playButton[0].style.display = "none";
    },

    showPlayButton() {
      let playButton = this.player
        .contentEl()
        .getElementsByClassName("vjs-big-play-button");
      playButton[0].style.display = "block";
    }
  },
  beforeDestroy() {}
};
</script>

<style lang="scss">
.vjs-tech {
  pointer-events: none;
}
</style>
<style lang="scss" scoped>
#vessel-voyage-history-camera {
  padding: 1px 1px 0.5px;
  .vjs-text {
    z-index: 1;
    font-size: 2em;
    line-height: 1.5em;
    height: 1.63332em;
    display: block;
    position: absolute;
    top: 10px;
    opacity: 1;
    transition: all 0.4s;
  }

  .live-camera-area {
    position: relative;
  }
  .live-camera-area p {
    position: absolute;
    top: 50%;
    left: 50%;
    -ms-transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    margin: 0;
    padding: 0;
    color: white;
    z-index: 5;
  }

  .live-camera-area button {
    z-index: 5;
    position: absolute;
    top: 80%;
    left: 50%;
    -ms-transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
  }

  .grid-view-item {
    .grid-view-img {
      max-width: 100%;
      max-height: 100%;
      width: auto;
      transition: 0.35s;
    }

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.25);

      .grid-view-img {
        opacity: 0.9;
      }
    }
  }
}
</style>
